import classNames from 'classnames'
import styles from './index.module.scss'
import Navbar from 'common/Navbar'
import ResetSupportBooking from 'common/ResetSupportBooking'
import useThriveAuth from 'hooks/useThriveAuth'
import { animated } from 'react-spring'
import { forwardRef } from 'react'
import Prenav from 'common/Prenav'
import useHeaderScrollAnimate from 'hooks/useHeaderScrollAnimate'
import useSalesforceLead from 'hooks/salesforce/useSalesforceLead'
import useSalesforceCase from 'hooks/salesforce/useSalesforceCase'

type PageContainerProps = {
  navContent?: JSX.Element
  navbarStyle?: string
  pageContainerClassName?: string
  hideNavContentOnMd?: boolean
  callUsBannerNumber?: CallUsNavBarBanner
  hideBookSessionButton?: boolean
  hideHelplineSection?: boolean
  hideAuthNavItems?: boolean
  hideNavOnScroll?: boolean
  navContainerHeight?: number
  children?: React.ReactNode
  isDiagnosticHelper?: boolean
  hideResetSupportBooking?: boolean
}

const baseHeaderHeight = 100
const navWithPrenavHeight = 139

const PageContainer = forwardRef<HTMLDivElement, PageContainerProps>(
  (
    {
      children,
      navContent,
      pageContainerClassName = '',
      callUsBannerNumber,
      hideBookSessionButton,
      hideHelplineSection = false,
      hideAuthNavItems,
      hideNavOnScroll = true,
      navContainerHeight = hideHelplineSection
        ? baseHeaderHeight
        : navWithPrenavHeight,
      isDiagnosticHelper = false,
      hideResetSupportBooking = false,
    },
    ref
  ) => {
    const { isSupportOrThirdPartyUser, isSupportUser } = useThriveAuth()
    const { hasLeadId } = useSalesforceLead()
    const { hasCaseId } = useSalesforceCase()
    const showPrenav = !isSupportUser || hasLeadId || hasCaseId
    const computedNavContainerHeight = showPrenav
      ? navContainerHeight
      : baseHeaderHeight
    const headerPositionStyle = useHeaderScrollAnimate({
      animation: {
        hide: `translateY(-${computedNavContainerHeight}px)`,
        show: 'translateY(0px)',
      },
      hideNavOnScroll,
      hideNavForSupportUsers: isSupportOrThirdPartyUser,
    })

    return (
      <div
        className={classNames('w-100 h-100 bg-light', pageContainerClassName)}
        style={{ paddingTop: computedNavContainerHeight }}
      >
        {/*---- Mini Header above Navbar with Helpline Number ----*/}
        {!hideHelplineSection && showPrenav && (
          <Prenav
            callUsBannerNumber={callUsBannerNumber}
            containerStyle={styles.fixed_navbar}
          />
        )}
        <animated.div
          ref={ref}
          className={classNames(styles.navbar_container, {
            [styles.navbar_height_without_prenav]: hideHelplineSection,
            [styles.navbar_container_coe]: !showPrenav,
          })}
          style={headerPositionStyle}
        >
          <Navbar
            hideBookSessionButton={hideBookSessionButton}
            hideAuthNavItems={hideAuthNavItems}
            isDiagnosticHelper={isDiagnosticHelper}
          >
            {navContent}
          </Navbar>
        </animated.div>
        {children}
        {isSupportOrThirdPartyUser &&
          !isDiagnosticHelper &&
          !hideResetSupportBooking && <ResetSupportBooking />}
      </div>
    )
  }
)

export default PageContainer
